module.exports = __webpack_public_path__ + "img/编组备份@3x.afea3f50.png";